## Keycloak

The Keycloak plugin allows you to integrate Hawtio console with Keycloak authentication.
